// tslint:disable
/**
 * Robotic Platform Pattern Generation API
 * WebSocket API contract for generating palletization strategy templates and layer layouts.  This module is exposed through the Robotic Platform WebSocket dispatcher (not a standalone REST API). The OpenAPI path below documents the JSON request/response message payload for the `generatePatternPlan` handler.  Transport notes: - Connect to the WebSocket server and send a JSON object with top-level `type: generatePatternPlan` - Receive one JSON response frame for the request (success or handler-level error) - Validation and internal handler errors are encoded in the JSON response body with `status: error` - No module-level authentication or rate limiting is implemented in this repository 
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { PalletSection } from './pallet-section';
import { SymmetryOptions } from './symmetry-options';

/**
 * Optional generation controls. If omitted, module defaults are used. The out-of-the-box backend default is to generate all supported strategies. The response is emitted as strategy templates (`A` base layer + `B` symmetry variants). 
 * @export
 * @interface GenerationOptions
 */
export interface GenerationOptions {
    [key: string]: object | any;

    /**
     * Strategy IDs to generate and evaluate. Acts as a request-time filter over supported pattern generators. If omitted, the backend generates all supported strategies unless module configuration overrides that default. 
     * @type {Array<string>}
     * @memberof GenerationOptions
     */
    strategies?: Array<GenerationOptionsStrategiesEnum>;
    /**
     * 
     * @type {PalletSection}
     * @memberof GenerationOptions
     */
    section?: PalletSection;
    /**
     * 
     * @type {SymmetryOptions}
     * @memberof GenerationOptions
     */
    symmetry?: SymmetryOptions;
}

/**
    * @export
    * @enum {string}
    */
export enum GenerationOptionsStrategiesEnum {
    COLUMN = 'column',
    INTERLOCK = 'interlock',
    SINGLE_SPIRAL = 'single_spiral',
    DOUBLE_SPIRAL = 'double_spiral',
    TRILOCK = 'trilock',
    ROWS_TRILOCK = 'rows_trilock'
}



